var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var Onboarding = function () {
            function Onboarding() {
                _classCallCheck(this, Onboarding);

                this.onboardingList = null;
                this.animation = null;
                this.currentOnboardingId = null;

                this.localStorageKey = 'onboardingListShown';

                this.currentOnboarding = {};
                this.dafaultParams = {
                    id: null,
                    parentSelector: null,
                    targetSelector: null,
                    contentId: null,
                    animationContainerId: null,
                    animationFilePath: null,
                    title: null,
                    hint: null,
                    scroll: true,
                    order: 0,
                    onlyViewPort: false,
                    scrollToAfterShow: null
                };

                this.onlyViewPortElementsList = [];

                this.handlers();
            }

            _createClass(Onboarding, [{
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    document.addEventListener('_show-onboarding', function (e) {
                        var params = e.detail;
                        if (!params) return;

                        _this.setOnboardingList();
                        if (!_this.onboardingList || _this.currentOnboardingId) return;

                        _this.currentOnboardingId = params.onboardingId;

                        // пропускаем, если уже был показан
                        var shown = _this.getFromLocalStorage();
                        if (shown.includes(_this.currentOnboardingId)) {
                            _this.currentOnboardingId = null;
                            _this.deleteOnboarding();
                            return;
                        }

                        if (_this.onboardingList[_this.currentOnboardingId]) {
                            var onboarding = Object.assign(_this.dafaultParams, _this.onboardingList[_this.currentOnboardingId]);
                            var parentElement = onboarding.parentSelector ? document.querySelector(onboarding.parentSelector) : document;
                            var targetElement = parentElement ? parentElement.querySelector(onboarding.targetSelector) : null;

                            if (onboarding.onlyViewPort) {
                                _this.onlyViewPortListener(onboarding);
                                _this.hide();
                                return;
                            }

                            _this.show(targetElement, onboarding);
                        } else {
                            _this.hide();
                        }
                    });

                    eventDispatcher.on('click', '#onboarding-backdrop', function (e) {
                        _this.hide();
                    });
                }
            }, {
                key: "getFromLocalStorage",
                value: function getFromLocalStorage() {
                    try {
                        var data = localStorage.getItem(this.localStorageKey);
                        return data ? JSON.parse(data) : [];
                    } catch (e) {
                        return [];
                    }
                }
            }, {
                key: "saveToLocalStorage",
                value: function saveToLocalStorage() {
                    var list = this.getFromLocalStorage();
                    if (!list.includes(this.currentOnboardingId)) {
                        list.push(this.currentOnboardingId);
                        localStorage.setItem(this.localStorageKey, JSON.stringify(list));
                    }
                }
            }, {
                key: "setOnboardingList",
                value: function setOnboardingList() {
                    var self = this;
                    if (window.app && window.app.onboardingList) {
                        this.onboardingList = {};

                        for (var key in window.app.onboardingList) {
                            // Берём дефолтные параметры + конкретный элемент
                            this.onboardingList[key] = Object.assign({}, // создаём новый объект
                            self.dafaultParams, // твои базовые значения
                            window.app.onboardingList[key] // текущий элемент
                            );
                        }
                    }
                }
            }, {
                key: "show",
                value: function show(targetElement, onboarding) {
                    if (!targetElement || targetElement.getClientRects().length === 0) {
                        this.hide();
                        return;
                    }

                    if (onboarding.parentSelector) {
                        document.querySelector(onboarding.parentSelector).classList.add('onboarding-wrapper');
                    }

                    if (onboarding.scroll) {
                        this.scrollTo(targetElement);
                    }

                    this.renderOnboardingContent(onboarding, targetElement);
                    this.saveToLocalStorage();
                    this.sendAnalytic('onboarding_show');

                    this.currentOnboarding = onboarding;
                }
            }, {
                key: "hide",
                value: function hide() {
                    var hint = document.querySelector('.onboarding-hint');
                    var target = document.querySelector('.onboarding-target');

                    if (hint) {
                        hint.remove();
                        target.classList.remove('onboarding-target');
                        this.stopAnimation();
                    }

                    if (this.currentOnboarding && this.currentOnboarding.parentSelector) {
                        document.querySelector(this.currentOnboarding.parentSelector).classList.remove('onboarding-wrapper');
                    }

                    if (this.onboardingList[this.currentOnboardingId]) {
                        if (this.onboardingList[this.currentOnboardingId].onlyViewPort === false) {
                            delete this.onboardingList[this.currentOnboardingId];
                            delete window.app.onboardingList[this.currentOnboardingId];
                        }
                    }

                    if (this.onboardingList.length === 0) {
                        this.deleteOnboarding();
                    }

                    var targetScroll = null;
                    if (this.currentOnboarding.scrollToAfterShow) {
                        targetScroll = document.querySelector(this.currentOnboarding.scrollToAfterShow);
                    }

                    this.currentOnboarding = {};

                    if (this.onboardingList && Object.keys(this.onboardingList).length > 0) {
                        if (this.onboardingList[this.currentOnboardingId]) {
                            if (this.onboardingList[this.currentOnboardingId].onlyViewPort === true) {
                                this.deleteOnboarding();
                                return;
                            }
                        }

                        this.currentOnboardingId = null;

                        var entries = Object.entries(this.onboardingList);

                        var sorted = entries.sort(function (_ref, _ref2) {
                            var _ref4 = _slicedToArray(_ref, 2),
                                a = _ref4[1];

                            var _ref3 = _slicedToArray(_ref2, 2),
                                b = _ref3[1];

                            var orderA = a && (typeof a === "undefined" ? "undefined" : _typeof(a)) === 'object' && 'order' in a ? a.order : 0;
                            var orderB = b && (typeof b === "undefined" ? "undefined" : _typeof(b)) === 'object' && 'order' in b ? b.order : 0;
                            return orderA - orderB;
                        });

                        var firstEntry = sorted[0];
                        if (firstEntry) {
                            var firstKey = firstEntry[0];

                            document.dispatchEvent(new CustomEvent('_show-onboarding', {
                                detail: { onboardingId: firstKey }
                            }));
                        }
                    } else {
                        if (targetScroll) {
                            this.scrollTo(targetScroll);
                        }
                        this.currentOnboardingId = null;
                        this.deleteOnboarding();
                    }
                }
            }, {
                key: "deleteOnboarding",
                value: function deleteOnboarding() {
                    if (document.querySelector('#onboarding-backdrop')) {
                        document.querySelector('#onboarding-backdrop').remove();
                    }

                    document.body.classList.remove('no-scroll');
                }
            }, {
                key: "scrollTo",
                value: function scrollTo(element) {
                    var fixedOffset = 300;

                    var rect = element.getBoundingClientRect();
                    var scrollTop = window.scrollY;
                    var targetScroll = scrollTop + rect.top - fixedOffset;

                    window.scrollTo({
                        top: targetScroll,
                        behavior: 'smooth'
                    });
                }
            }, {
                key: "renderOnboardingContent",
                value: function renderOnboardingContent(onboarding, targetElement) {
                    var animation = this.renderAnimationContent(onboarding);
                    var textContent = this.renderTextContent(onboarding);

                    var hint = '<div class="onboarding-hint">' + animation + textContent + '</div>';

                    var wrapper = document.createElement('div');
                    wrapper.innerHTML = hint;
                    var element = wrapper.firstElementChild;
                    element.classList.add(onboarding.contentId);
                    targetElement.insertAdjacentElement('beforeend', element);

                    this.startAnimation(onboarding);

                    var backdrop = document.querySelector('#onboarding-backdrop');

                    if (!backdrop) {
                        document.body.insertAdjacentHTML('beforeend', '<div id="onboarding-backdrop"></div>');
                    }

                    //const rect = targetElement.getBoundingClientRect();
                    targetElement.classList.add('onboarding-target');
                    document.body.classList.add('no-scroll');
                }
            }, {
                key: "renderAnimationContent",
                value: function renderAnimationContent(onboarding) {
                    var id = onboarding.animationContainerId;
                    var src = onboarding.animationFilePath;
                    return '<div id="' + id + '" class="onboarding-animation" data-src="' + src + '"></div>';
                }
            }, {
                key: "renderTextContent",
                value: function renderTextContent(onboarding) {
                    var title = '<div class="onboarding__title">' + onboarding.title + '</div>';
                    var text = '<div class="onboarding__text">' + onboarding.hint + '</div>';

                    return '<div>' + title + text + '</div>';
                }
            }, {
                key: "startAnimation",
                value: function startAnimation(onboarding) {
                    var container = document.querySelector('#' + onboarding.animationContainerId);
                    if (!container) {
                        return;
                    }

                    this.animation = lottie.loadAnimation({
                        container: container,
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        path: onboarding.animationFilePath
                    });
                }
            }, {
                key: "stopAnimation",
                value: function stopAnimation() {
                    this.animation.destroy();
                }
            }, {
                key: "sendAnalytic",
                value: function sendAnalytic(eventName) {
                    var eventProperties = {};
                    eventProperties['Onboarding Id'] = this.currentOnboardingId;
                    window.brxTracking.sendAnalyticsEvent(eventName, eventProperties);
                }
            }, {
                key: "onlyViewPortListener",
                value: function onlyViewPortListener(onboarding) {
                    this.onlyViewPortElementsList.push(onboarding);
                    var self = this;

                    var observer = new IntersectionObserver(function (entries, observer) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                observer.unobserve(entry.target);

                                // находим соответствующий объект в списке и меняем флаг
                                var found = Object.values(window.app.onboardingList).find(function (el) {
                                    return entry.target.matches(el.targetSelector);
                                });
                                if (found) {
                                    found.onlyViewPort = false;
                                    self.currentOnboardingId = null;

                                    document.dispatchEvent(new CustomEvent('_show-onboarding', {
                                        detail: { onboardingId: found.id }
                                    }));
                                }
                            }
                        });
                    }, { threshold: 0.1 });

                    for (var index in this.onlyViewPortElementsList) {
                        var element = document.querySelector(this.onlyViewPortElementsList[index].targetSelector);
                        if (element) observer.observe(element);
                    }
                }
            }]);

            return Onboarding;
        }();

        window.Onboarding = Onboarding;
    }, {}] }, {}, [1]);